var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLayer6(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 531,
    height: 301,
    viewBox: "0 0 531 301",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M469.34 1.79688H65.6121C58.4283 1.79688 52.5615 7.54388 52.5615 14.7276V284.837H54.4772V12.812C54.4772 12.2134 54.4772 11.7344 54.5969 11.1358C54.5969 10.8963 54.7167 10.7766 54.7167 10.5371C54.7167 10.4174 54.8364 10.178 54.8364 10.0582C54.8364 9.93851 54.9561 9.69902 54.9561 9.57929C55.435 8.14254 56.1534 6.82553 57.231 5.62823C57.3507 5.5085 57.4704 5.38879 57.5902 5.26906C57.7099 5.14933 57.7099 5.14932 57.8296 5.02959C58.4283 4.43094 59.0269 3.95204 59.7453 3.47312C59.9848 3.35339 60.2242 3.2336 60.4637 3.11387C60.7031 2.99414 60.9426 2.87443 61.182 2.7547C61.3018 2.63497 61.5412 2.63495 61.661 2.51522C62.978 2.0363 64.295 1.79688 65.7318 1.79688H469.34C471.256 1.79688 473.052 2.27576 474.608 3.11387C474.848 3.2336 475.087 3.35339 475.326 3.47312C475.686 3.71258 475.925 3.83231 476.164 4.07176C476.284 4.19149 476.404 4.31121 476.524 4.43094C476.763 4.55067 476.883 4.79013 477.122 5.02959C477.242 5.14932 477.242 5.14933 477.362 5.26906C477.482 5.38879 477.601 5.5085 477.721 5.62823C479.397 7.54391 480.475 10.0582 480.475 12.812V284.718H482.39V13.8895C482.031 7.18467 476.284 1.79688 469.34 1.79688Z",
    fill: "#00293E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M52.4414 12.9308C52.4414 5.747 58.3081 0 65.4919 0H469.339C476.523 0 482.39 5.747 482.39 12.9308V14.0084C481.911 7.30351 476.284 1.91564 469.339 1.91564H65.6117C58.4279 1.91564 52.5611 7.66272 52.5611 14.8465L52.4414 12.9308Z",
    fill: "#00293E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M480.594 277.293H54.3574V284.836H480.594V277.293Z",
    fill: "#3D3D3D"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M480.594 12.9317V277.294H54.3574V12.9317C54.3574 6.8255 59.3861 1.79688 65.612 1.79688H469.46C475.566 1.79688 480.594 6.8255 480.594 12.9317Z",
    fill: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M482.39 284.836V285.554H480.594H54.3571H52.4414V284.836H482.39Z",
    fill: "#666666"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M0.5 292.957V286.414H264.821V292.957H0.5Z",
    stroke: "#00293E"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M265.82 292.957V286.414H530.141V292.957H265.82Z",
    stroke: "#00293E"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M302.512 286.055C302.387 287.398 301.767 288.63 300.886 289.511C299.895 290.501 298.464 291.161 296.929 291.161H233.712C230.804 291.161 228.384 288.9 228.128 286.055H302.512Z",
    stroke: "#00293E"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M57.5899 300.502C39.5378 300.502 21.5887 298.448 4.21845 294.438H265.321H526.183C508.813 298.448 490.864 300.502 472.812 300.502H265.201H57.5899Z",
    stroke: "#00293E"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M471.375 17.9609H63.0977V270.59H471.375V17.9609Z",
    fill: "url(#paint0_linear_155_7424)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_155_7424",
    x1: 102.072,
    y1: -21.0006,
    x2: 432.601,
    y2: 309.492,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F2F3F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3559,
    stopColor: "#EDEEEF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7827,
    stopColor: "#DFE0E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D5D6D6"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLayer6);
export default __webpack_public_path__ + "static/media/Layer_6.f39f06cce739d05d52e6b11bc9c5ca35.svg";
export { ForwardRef as ReactComponent };